import { IconListView } from "../../icons/IconListView/IconListView";
import { IconTreeView } from "../../icons/IconTreeView/IconTreeView";
import "./ListTreeViewToggle.scss";

export interface ListTreeViewToggleProps {
  isTreeView: boolean;
  onToggle: () => void;
  disabled?: boolean;
  label: string;
  className?: string;
}

export const ListTreeViewToggle = ({
  isTreeView,
  onToggle,
  disabled = false,
  label,
  className = "",
}: ListTreeViewToggleProps) => {
  const getListVariant = () => {
    if (disabled) return "active";
    return !isTreeView ? "active" : "inactive";
  };

  const getTreeVariant = () => {
    if (disabled) return "disabled";
    return isTreeView ? "active" : "inactive";
  };

  return (
    <div className={`ListTreeViewToggle ${className} ${disabled ? "ListTreeViewToggle--disabled" : ""}`}>
      <button
        type="button"
        className={`ListTreeViewToggle__button ListTreeViewToggle__button--left ${!isTreeView ? "ListTreeViewToggle__button--active" : ""}`}
        onClick={() => {
          if (isTreeView) onToggle();
        }}
        disabled={disabled}
        aria-label={`${label} - List view`}
        aria-pressed={!isTreeView}
      >
        <IconListView variant={getListVariant()} />
      </button>
      <button
        type="button"
        className={`ListTreeViewToggle__button ListTreeViewToggle__button--right ${
          isTreeView ? "ListTreeViewToggle__button--active" : ""
        }`}
        onClick={() => {
          if (!isTreeView) onToggle();
        }}
        disabled={disabled}
        aria-label={`${label} - Tree view`}
        aria-pressed={isTreeView}
        data-testid="list-tree-view-toggle-tree"
      >
        <IconTreeView variant={getTreeVariant()} />
      </button>
    </div>
  );
};
